import React from 'react';
import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { ExplanationContainer } from '../../styled';
import messages from './messages';

const GoalTitleComponent = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Heading size="xsmall" as="h2">
				<Box>{formatMessage(messages.goals)}</Box>
			</Heading>
			<ExplanationContainer>{formatMessage(messages.metricInformationTip)}</ExplanationContainer>
		</>
	);
};

export const GoalTitle = GoalTitleComponent;
